export default __webpack_public_path__ + "static/B0286-3f1467e30cfed39ff0f59ecb9f02db97.png";